import { Service, Inject } from 'vue-di-container';
import AxiosService from '@/Services/AxiosService';
import LoaderService from '@/Services/LoaderService';
import { ReportModel } from './ReportModel';
import FileSaver from 'file-saver';

@Service()
export default class ReportService {
    @Inject(AxiosService) public axiosService!: AxiosService;
    @Inject(LoaderService) public loaderService!: LoaderService;
    public async GetSenderNameAndBeneficiariesReport(
        model: ReportModel, pageIndex: string,
        pageSize: string, IsExport: boolean): Promise<any> {
        const baseURL = IsExport ? 'api/report/export-sendername-and-beneficiaries-report' :
            'api/report/sendername-and-beneficiaries-report';
        const url = window.$config.HostName + baseURL;
        const result = await this.axiosService.axiosInstance.post(url, model);
        if (result.data.isSuccess) {
            if (IsExport) {
                const array = Buffer.from(result.data.result, 'base64');
                const blob = new Blob([array], { type: 'application/vnd.ms-excel' });
                FileSaver.saveAs(blob, 'SenderNameAndBeneficiariesReport.xlsx');
                return result.data;
            } else {
                return result.data;
            }
        } else {
            return result.data;
        }
    }

    public async GetContractRequestsReport(
        model: ReportModel, pageIndex: string,
        pageSize: string, IsExport: boolean): Promise<any> {
        const url = window.$config.HostName + 'api/report/export-contract-requests-report';
        const result = await this.axiosService.axiosInstance.post(url, model);
        if (result.data.isSuccess) {
            if (IsExport) {
                const array = Buffer.from(result.data.result, 'base64');
                const blob = new Blob([array], { type: 'application/vnd.ms-excel' });
                FileSaver.saveAs(blob, 'Contract Requests Report.xlsx');
                return result.data;
            } else {
                return result.data;
            }
        } else {
            return result.data;
        }
    }
}